import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else {
          return {
            minutes: 0,
            seconds: 0
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="bg-amber-600 text-white py-8 px-4" data-id="element-38">
      <div className="max-w-4xl mx-auto text-center" data-id="element-39">
        <p className="text-2xl md:text-3xl font-bold" data-id="element-40">
          ⏱️ ESTA OFERTA EXPIRA EN:
          <span className="ml-4 font-mono text-4xl" data-id="element-41">
            {String(timeLeft.minutes).padStart(2, '0')}:
            {String(timeLeft.seconds).padStart(2, '0')}
          </span>
        </p>
      </div>
    </section>;
}